{ "closeAria": "Fechar", "historyAria": "Histórico de solicitações", "supportTitle": "Suporte" }
